import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';


@Component({
  selector: 'app-table-dedicated-ip-default',
  templateUrl: './table-dedicated-ip-default.component.html',
  styleUrls: ['./table-dedicated-ip-default.component.scss']
})
export class TableDedicatedIpDefaultComponent implements ViewCell, OnInit {

  @Input() rowData: any;
  @Input() value: string | number;


  statusText: string;
  statusClass: string;
  
 
  @Output() icon1Click: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit() {
   
    if( this.rowData.is_default == 1 ){     // if Default set
      
      this.statusText = 'Remove Default';
      //this.cssForStatus = 'status-link disabled currentplan';
      //this.cssForIcon = 'icon-check-mark';
      this.statusClass = 'active';
    }
    else if (this.rowData.is_default == 0 ) {  
     
      this.statusText = 'Set As Default';
      this.statusClass = 'in-active';
    } 

  }

  onIcon1Click() {
    this.icon1Click.emit(this.rowData);
    return false;
  }
  
}
